import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid, MenuItem, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

const selectFieldProps = {
  InputLabelProps: { shrink: true },
  sx: {
    "& .MuiOutlinedInput-root": {
      minHeight: 56,
      alignItems: "center",
    },
  },
};

function AddExamListSet() {
  const [redirect, setRedirect] = useState(false);
  const [notification, setNotification] = useState({ open: false, color: "success", message: "" });
  const [allExamLists, setAllExamLists] = useState([]);
  const [form, setForm] = useState({
    exam_list_id: "",
    set_name: "",
    number_of_questions: 20,
    time_duration: 20,
    is_locked: false,
    is_paid: false,
    min_cut_off: 0,
    status: "inactive",
  });

  const showMessage = (message, color = "success", shouldRedirect = false) => {
    setNotification({ open: true, color, message });
    setTimeout(() => {
      setNotification({ open: false, color, message: "" });
      if (shouldRedirect) setRedirect(true);
    }, 2500);
  };

  useEffect(() => {
    const loadOptions = async () => {
      try {
        const examListResp = await axios.get(Constants.getUrls.getPyqMetaExamLists);
        setAllExamLists(examListResp?.data?.data || []);
      } catch (error) {
        showMessage("Unable to load exam list options.", "error");
      }
    };

    loadOptions();
  }, []);

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(Constants.postUrls.createExamListSet, form);
      showMessage("Exam list set created successfully!", "success", true);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to create exam list set.", "error");
    }
  };

  if (redirect) return <Navigate to="/exam-list-sets" />;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
            <MDTypography variant="h6" color="white">
              Create Exam List Set
            </MDTypography>
          </MDBox>
          <MDBox py={3} px={2}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Exam List"
                    value={form.exam_list_id}
                    onChange={(e) => handleChange("exam_list_id", e.target.value)}
                    {...selectFieldProps}
                  >
                    <MenuItem value="">Select Exam List</MenuItem>
                    {allExamLists.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        {item?.exam_id?.exam_name || "Exam"} • {item?.year_id?.year || "Year"} • {item.exam_name}
                        {item?.shift ? ` • ${item.shift}` : ""}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Set Name"
                    value={form.set_name}
                    onChange={(e) => handleChange("set_name", e.target.value)}
                    placeholder="Set 1"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Number of Questions"
                    value={form.number_of_questions}
                    onChange={(e) => handleChange("number_of_questions", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Time Duration (min)"
                    value={form.time_duration}
                    onChange={(e) => handleChange("time_duration", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    select
                    fullWidth
                    label="Locked"
                    value={String(form.is_locked)}
                    onChange={(e) => handleChange("is_locked", e.target.value === "true")}
                    {...selectFieldProps}
                  >
                    <MenuItem value="false">No</MenuItem>
                    <MenuItem value="true">Yes</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    select
                    fullWidth
                    label="Paid"
                    value={String(form.is_paid)}
                    onChange={(e) => handleChange("is_paid", e.target.value === "true")}
                    {...selectFieldProps}
                  >
                    <MenuItem value="false">No</MenuItem>
                    <MenuItem value="true">Yes</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Min Cutoff"
                    value={form.min_cut_off}
                    onChange={(e) => handleChange("min_cut_off", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    select
                    fullWidth
                    label="Status"
                    value={form.status}
                    onChange={(e) => handleChange("status", e.target.value)}
                    {...selectFieldProps}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                    <MenuItem value="active_for_admin">Active For Admin</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              <Grid align="left" mt={2}>
                <MDButton variant="contained" size="small" color="info" type="submit">
                  Create
                </MDButton>
              </Grid>
            </form>
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddExamListSet;
